<template>
    <div class="flex flex-wrap gap-2 items-start justify-evenlly my-4">
        <div v-for="tipo in tiposFotos" :key="tipo.id" :class="tipo.imagemUpload == '' ? 'botao-foto-upload' : ''">
            <div v-if="tipo.imagemUpload == ''" class="flex flex-col justify-center items-center">
                <img class="w-12 h-12 cursor-pointer" :src="tipo.imagem" alt="Câmera">
                <span class="w-full cursor-pointer text-center mt-1">{{ tipo.label }}</span>
            </div>
            <div v-else class="foto-carregada h-24 pb-2" :id="tipo.id">
                <div class="flex flex-col items-center">
                    <img class="w-28 h-20 " :src="tipo.imagemUpload" alt="Foto">
                    <div class="cursor-pointer text-xs">{{ tipo.label }}</div>
                </div>
            </div>
        </div>
        <div v-if="outrasFotos.length > 0">
            <div  v-for="outra in outrasFotos" :key="outra.tipo" :id="outra.id" class="foto-carregada h-24">
                <div class="flex flex-col items-center">
                    <img class="w-28 h-20 " :src="outra.imagem" alt="Foto">
                    <span class="cursor-pointer text-xs">{{ outra.observacao || outra.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'FotoResumo',
    props: {
        tiposFotos: {
            type: Array,
            required: true
        },
        outrasFotos: {
            type: Array,
            required: false,
            default: () => []
        }
    }
});
</script>